export const TRACE_DIRECTIVE_SELECTOR = '[trace]';
